import baseApi from './baseApi'

export const specialityApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSpecialities: builder.query({
      query: () => 'get_all_speciality',
      transformResponse: (data) => Object.values(data.get_cat),
    }),
    getSpeciality: builder.query({
      query: () => 'get_all_speciality',
      transformResponse: (data) => {
        return Object.entries(data.get_cat).map(([id, speciality]) => ({ label: speciality, value: id }))
      },
      providesTags: ['speciality'],
    }),
    addSpeciality: builder.mutation({
      query: ({ newSpeciality }) => ({
        method: 'POST',
        url: `/add_speciality`,
        body: { add_speciality: newSpeciality },
      }),
      invalidatesTags: ['speciality'],
    }),
    deleteSpeciality: builder.mutation({
      query: ({ id }) => ({
        method: 'POST',
        url: `/delete_speciality`,
        body: { id_uid: id },
      }),
      invalidatesTags: ['speciality'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetSpecialitiesQuery,
  useGetSpecialityQuery,
  useAddSpecialityMutation,
  useDeleteSpecialityMutation,
} = specialityApi
export default specialityApi
